// src/stone/icons/LogoRaioX2X.tsx
import { jsx } from "react/jsx-runtime";
var LogoRaioX2X = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M12.715 9h25.57l-4.333 8.667H8.382zm1.236 2-2.333 4.667h21.097L35.05 11zM6.049 22.333h25.57L27.284 31H1.715zm1.236 2L4.95 29H26.05l2.333-4.667z" })
  }
);
var LogoRaioX2X_default = LogoRaioX2X;

export {
  LogoRaioX2X_default
};
